import type { SubTab, Tab } from './navbar-types';

export const ACCOUNT_SUBTABS: SubTab[] = [
  { label: 'Profile', href: '/account', internal: true },
  { label: 'Change Password', href: '/account/password', internal: false },
  { label: 'My Events', href: '/account/events', internal: true },
  { label: 'My Investing Entities', href: '/account/investingentities', internal: false },
  { label: 'Favorite/Hidden Properties', href: '/account/properties', internal: true },
  { label: 'Favorite/Hidden Mortgages', href: '/account/mortgages', internal: true },
  { label: 'Bookmarked Education', href: '/account/bookmarks', internal: true },
  { label: 'Employee Resources', href: '/account/resources', internal: true },
];

export const ADMIN_SUBTABS: SubTab[] = [
  { label: 'Users', href: '/admin', internal: false },
  { label: 'Client Interactions', href: '/admin/clientinteractions', internal: false },
  { label: 'E-mails', href: '/admin/emails', internal: false },
  { label: 'Employee Resources', href: '/admin/resources', internal: false },
  { label: 'FAQs', href: '/admin/faqs', internal: false },
  { label: 'Agent Pages', href: '/admin/agents', internal: false },
  { label: 'Preferred Vendors', href: '/admin/vendors', internal: false },
  { label: 'Redirects', href: '/admin/redirects', internal: false },
  { label: 'Reports', href: '/admin/reports', internal: false },
  { label: 'Videos', href: '/admin/videos', internal: false },
  { label: 'Property Metrics', href: '/admin/properties/metrics', internal: false },
  { label: 'Property Markets', href: '/admin/properties/markets', internal: false },
  { label: 'Mortgage Rates and Fees', href: '/admin/mortgages/metrics', internal: false },
  { label: 'Mortgage Markets', href: '/admin/mortgages/markets', internal: false },
  { label: 'Loan Applications', href: '/admin/mortgages/applications', internal: false },
  { label: 'Authors', href: '/admin/authors', internal: false },
  { label: 'CTAs', href: '/admin/ctas', internal: false },
];

export const TABS: Tab[] = [
  {
    label: 'Invest',
    internal: false,
    subtabs: [
      { label: 'Properties', href: '/properties', internal: false },
      { label: 'Mortgages', href: '/mortgages', internal: false },
      {
        label: 'Investment Fund',
        href: '/fund/marshall-reddick-mortgage-fund',
        internal: false,
      },
    ],
  },
  {
    label: 'Borrow',
    internal: false,
    subtabs: [
      { label: 'Loan Application', href: '/borrow', internal: false },
      { label: 'Loan Programs', href: '/loan-programs', internal: false },
    ],
  },
  {
    label: 'Services',
    internal: false,
    subtabs: [
      { label: 'Realtors for Buying', href: '/buy', internal: true },
      { label: 'Realtors for Selling', href: '/sell', internal: true },
      { label: 'Homes for Rent', href: '/rentals', internal: false },
      { label: 'Property Management', href: '/management', internal: true },
    ],
  },
  {
    label: 'Learn',
    internal: false,
    subtabs: [
      { label: 'Education', href: '/learn', internal: false },
      { label: 'FAQ', href: '/learn/faq', internal: false },
      { label: 'Connect with an Advisor', href: '/consultation', internal: false },
    ],
  },
  {
    label: 'Events',
    href: '/events',
    internal: true,
  },
];

export const PROFILE_PUBLIC_SUBTABS: SubTab[] = [
  { label: 'My Account', href: '/account', subtabs: ACCOUNT_SUBTABS, internal: true },
  {
    label: 'Investment Fund Portal',
    href: 'https://app.appfolioim.com/marshallreddick/investor',
    internal: false,
  },
  { label: 'Mortgage Investor Portal', href: '/lender', internal: false },
  { label: 'Borrower Portal', href: '/borrower', internal: false },
  {
    label: 'Landlord Portal',
    href: 'https://marshallreddick.appfolio.com/oportal',
    internal: false,
  },
  {
    label: 'Tenant Portal',
    href: 'https://marshallreddick.appfolio.com/connect',
    internal: false,
  },
];

export const PROFILE_MR_EMPLOYEE_SUBTABS: SubTab[] = [
  { label: 'CRM', href: `${process.env.NEXT_PUBLIC_CRM_URL}`, internal: false },
  { label: 'Administration', href: '/admin', subtabs: ADMIN_SUBTABS, internal: false },
];
